<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Amount">
                    <AmountSelector :subunits="false" />              
                    <ErrorLabel field="amount" />
                </FormSection>
                <FormSection title="Payment Option">
                	<div class="frequency">
                    <PaymentOptions addMonthly />
                  </div>
                  <InHonorOf /> 
                </FormSection>                
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                        <Consent privacy="https://www.ou.org/privacy-policy/"/>
                    </FormRow>                     
                </FormSection>                
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="">
										<FormRow>
												<FormLabel class="control-label">
													Notes
											</FormLabel>
										</FormRow>									
										<FormRow>
											<FormInput type="textarea" class="width-half" field="custom.Notes"/>                      
										</FormRow> 
								</FormSection>                
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                    </FormRow>
                 </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<style scoped lang="scss">

::v-deep .form-container.ou-donation-form{
    background: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    max-width: 700px !important;
    margin: -120px auto 100px;
    padding: 40px 20px;


    h2{
        color: #477277;
        display: block;
        font-weight: lighter;
        font-size: 22px;
    }
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part{
    @media (min-width: 720px) {
        min-width: 33.3%;
    }

    label{
      color: #dddddd;
          border: 2px solid #dddddd;
    font-size: 26px;
    line-height: 1.2;
    text-transform: uppercase;
    font-weight: 700;
    }
}

::v-deep .styled-radio--ou-donation .amount_other__wrapper{
    background: white;
    color: #dddddd;
    text-align: center;
    font-weight: 700;
    cursor: pointer;
    border: 2px solid #dddddd;
    font-size: 26px;
    line-height: 1.2;
    text-transform: uppercase;
    display: flex;
    align-items: center;

    @media (max-width: 720px) {
    min-width: 100%;
    width: 100%;
    }


    input{
      color: #dddddd;
      font-weight: 700; 
      font-size: 26px;
      line-height: 1.2;
      text-transform: uppercase;

      &#amount_other_field{
            margin-top: 0px;
            margin-bottom: 0px;

            &:hover,
            &:focus{
              border: none;
              box-shadow: none;
            }
      }
    }
}
::v-deep .styled-radio.styled-radio--ou-donation.row{
  .vs__search, .vs__search:focus {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none !important;
      line-height: 1.85;
      font-size: 1em;
      border: 1px solid transparent !important;
      border-left: none !important;
      outline: none !important;
      margin: 4px 0 0 !important;
      padding: 0 7px !important;
      background: none !important;
      box-shadow: none;
      width: 0 !important;
      max-width: 100%;
      flex-grow: 1;
  }

  .currency-selector ::v-deep .v-select {
  background: #f7f9fb;
  height: 42px;

  .vs__dropdown-toggle {
    border-color: #ddd;
  }
}

}


h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.frequency{
	margin-top: 20px;
}
</style>

